// Configuracao das promocoes automaticas (curadoria) por loja.
// Normaliza a linha crua de auto_promotion_configs e serializa para a RPC
// save_auto_promotion_config. Valores invalidos caem no default seguro.
import { sanitizeCategoryIds } from "./categories.js";
export const AUTO_PROMOTION_PROVIDERS = ["shopee", "mercadolivre"];
export const INTERVAL_OPTIONS = [30, 60, 120, 180, 360, 720];
export const MIN_ITEMS_PER_CYCLE = 1;
export const MAX_ITEMS_PER_CYCLE = 10;
export const MAX_DESTINATIONS_PER_PLATFORM = 10;
/** Janela do anti-repeticao: o mesmo produto nao volta antes disso. */
export const SENT_DEDUP_DAYS = 7;
export const DEFAULT_FILTERS = Object.freeze({
    minDiscountPercent: 20,
    minCommissionPercent: 5,
    minSales: 50,
    minRating: 4.5,
    maxPriceCents: null,
});
export function defaultAutoPromotionConfig(provider) {
    return {
        provider,
        enabled: false,
        categoryIds: [],
        intervalMinutes: 360,
        itemsPerCycle: 3,
        filters: DEFAULT_FILTERS,
        destinations: { telegram: [], whatsapp: [] },
    };
}
export function isAutoPromotionProvider(value) {
    return value === "shopee" || value === "mercadolivre";
}
function asRecord(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value) ? value : {};
}
/** Numero finito dentro de [min, max]; fora disso ou ausente = null (sem filtro). */
function boundedOrNull(value, min, max) {
    const n = typeof value === "string" && value.trim() !== "" ? Number(value) : value;
    if (typeof n !== "number" || !Number.isFinite(n) || n < min || n > max) {
        return null;
    }
    return n;
}
function normalizeInterval(value) {
    return INTERVAL_OPTIONS.includes(value)
        ? value
        : 360;
}
function normalizeItems(value) {
    if (typeof value !== "number" || !Number.isInteger(value)) {
        return 3;
    }
    return Math.min(MAX_ITEMS_PER_CYCLE, Math.max(MIN_ITEMS_PER_CYCLE, value));
}
function normalizeRefs(value) {
    if (!Array.isArray(value)) {
        return [];
    }
    const refs = value.filter((v) => typeof v === "string" && v.trim().length > 0);
    return [...new Set(refs)].slice(0, MAX_DESTINATIONS_PER_PLATFORM);
}
export function normalizeFilters(raw) {
    const r = asRecord(raw);
    const price = boundedOrNull(r["max_price_cents"], 1, 100_000_000);
    const sales = boundedOrNull(r["min_sales"], 0, 10_000_000);
    return {
        minDiscountPercent: boundedOrNull(r["min_discount_percent"], 0, 99),
        minCommissionPercent: boundedOrNull(r["min_commission_percent"], 0, 100),
        minSales: sales === null ? null : Math.floor(sales),
        minRating: boundedOrNull(r["min_rating"], 0, 5),
        maxPriceCents: price === null ? null : Math.round(price),
    };
}
/** Linha crua (snake_case) -> config valida. Linha ausente = default da loja. */
export function normalizeAutoPromotionConfig(provider, raw) {
    if (raw === null || raw === undefined) {
        return defaultAutoPromotionConfig(provider);
    }
    const r = asRecord(raw);
    return {
        provider,
        enabled: r["enabled"] === true,
        categoryIds: sanitizeCategoryIds(Array.isArray(r["category_ids"]) ? r["category_ids"] : []),
        intervalMinutes: normalizeInterval(r["interval_minutes"]),
        itemsPerCycle: normalizeItems(r["items_per_cycle"]),
        filters: normalizeFilters(r),
        destinations: {
            telegram: normalizeRefs(r["destinations_telegram"]),
            whatsapp: normalizeRefs(r["destinations_whatsapp"]),
        },
    };
}
/** Payload jsonb aceito por save_auto_promotion_config. */
export function serializeAutoPromotionConfig(config) {
    return {
        enabled: config.enabled,
        category_ids: [...config.categoryIds],
        interval_minutes: config.intervalMinutes,
        items_per_cycle: config.itemsPerCycle,
        min_discount_percent: config.filters.minDiscountPercent,
        min_commission_percent: config.filters.minCommissionPercent,
        min_sales: config.filters.minSales,
        min_rating: config.filters.minRating,
        max_price_cents: config.filters.maxPriceCents,
        destinations_telegram: [...config.destinations.telegram],
        destinations_whatsapp: [...config.destinations.whatsapp],
    };
}
export function destinationCount(destinations) {
    return destinations.telegram.length + destinations.whatsapp.length;
}
//# sourceMappingURL=config.js.map